module.exports = __webpack_public_path__ + "img/flags/CK.de5a831.png";